import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '@app/core/services/state.service';

@Component({
  selector: 'tt-activity-type-act-status',
  templateUrl: './activity-type-act-status.component.html',
  styleUrls: ['./activity-type-act-status.component.css']
})
export class ActivityTypeActStatusComponent implements OnInit {
    activityTypeActStatusKeyno;

    public edit?: Edit;

    public activityTypeNameButtons: FormButton[] = [{
        id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'activitytype', gotoParms: () => ({ activitytype_no: this.edit!.activitytype_no })
    }];

    public activityStatusNameButtons: FormButton[] = [{
        id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'actstatusmenu', gotoParms: () => ({ actstatus_keyno: this.edit!.actstatus_keyno })
    }];

    public saving = false;

    constructor(private datatask: DataTaskService, private state: StateService) {
        this.activityTypeActStatusKeyno = this.state.getStateParams()['activitytypeactstatus_keyno'];
    }

    private async loadEdit() {
        if (!!this.activityTypeActStatusKeyno) {
            this.edit = (await this.datatask.Post(1339, { activitytypeactstatus_keyno: this.activityTypeActStatusKeyno }))[0];
    	}
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(1340, this.edit);

                this.state.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit(): void {
        this.init();
    }
}

interface Edit {
    activitytype_no: string;
    actstatus_keyno: string;
    activitytype_name: string;
    actstatus_name: string;
    isactive: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('activityTypeActStatus', {
//        templateUrl: 'views/components/views/activityTypeActStatus/activityTypeActStatus.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'activityTypeActStatusService', function ($stateParams, stateService, activityTypeActStatusService) {
//            const vm = this;
//            let activityTypeActStatusKeyno = $stateParams.activitytypeactstatus_keyno;

//            vm.model = {
//                activityTypeNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('activitytype', { activitytype_no: vm.model.edit.activitytype_no }) }
//                ],
//                activityStatusNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('actstatusmenu', { actstatus_keyno: vm.model.edit.actstatus_keyno }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            async function loadEdit() {
//                vm.model.edit = (await activityTypeActStatusService.getSetting({ activitytypeactstatus_keyno: activityTypeActStatusKeyno }))[0];
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                activityTypeActStatusService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            vm.$onInit = function () {
//                loadEdit();
//            }
//        }]
//    });
//})();
